import { useFormContext } from 'react-hook-form'
import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { uf } from '@/app/utils/uf'
import { BasicSelect } from '@/view/components/BasicSelect'
import { orgs } from '@/app/utils/orgs'
import { phoneMask } from '@/app/utils/phoneFormater'
import { customStyles } from './CustomStyles'
import { CreditClientFormData } from './schema'

interface PersonalInfoStepProps {
  visible: boolean
  onNext: () => void
  onBack: () => void
}

export function PersonalInfoStep({
  visible,
  onNext,
  onBack,
}: PersonalInfoStepProps) {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<CreditClientFormData>()

  const handleNext = () => {
    onNext()
  }

  const isFormValid = () => {
    const personalInfo = watch('personalInfo')
    return (
      personalInfo.email &&
      personalInfo.phone &&
      personalInfo.rg.number &&
      personalInfo.rg.date &&
      personalInfo.rg.uf &&
      personalInfo.rg.org
    )
  }

  if (!visible) return null

  return (
    <div className="flex flex-col">
      <div className="mb-5 p-6">
        <h1 className="mb-2 text-xl font-semibold text-black01 sm:text-2xl">
          Complete suas informações para solicitar o crédito
        </h1>
        <p className="text-sm font-medium text-black01 sm:text-base">
          Forneça seus dados para darmos continuidade ao seu pedido. É rápido,
          seguro e sem compromisso.
        </p>
      </div>

      <div className="flex h-full flex-col justify-between p-6">
        <div className="flex w-full flex-col gap-4">
          <BasicInput
            {...register('personalInfo.email')}
            type="email"
            placeholder="example@email.com"
            label="E-mail"
            error={errors.personalInfo?.email?.message}
          />

          <BasicInput
            {...register('personalInfo.phone')}
            label="Telefone"
            placeholder="(11) 99999-9999"
            onInput={phoneMask}
            error={errors.personalInfo?.phone?.message}
          />

          <BasicInput
            {...register('personalInfo.rg.number')}
            label="RG"
            placeholder="00.000.000-0"
            error={errors.personalInfo?.rg?.number?.message}
          />
          <div className="flex items-center gap-4">
            <BasicInput
              {...register('personalInfo.rg.date')}
              label="Data de emissão"
              placeholder="00/00/0000"
              type="date"
              error={errors.personalInfo?.rg?.date?.message}
            />

            <BasicSelect
              name="personalInfo.rg.uf"
              label="UF de emissão"
              options={uf}
              placeholder="UF de emissão"
              styles={customStyles}
              error={errors.personalInfo?.rg?.uf?.message}
            />
          </div>

          <BasicSelect
            name="personalInfo.rg.org"
            label="Orgão emissor"
            options={orgs}
            placeholder="Selecione o Órgão emissor"
            styles={customStyles}
            error={errors.personalInfo?.rg?.org?.message}
          />
        </div>
      </div>

      <div className="mt-10 flex w-full items-center justify-center gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          className="w-full rounded-full bg-gray01 px-8 py-3"
        >
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleNext}
          disabled={!isFormValid()}
          className="w-full rounded-full bg-primary px-8 py-3"
        >
          Continuar
        </Button>
      </div>
    </div>
  )
}
